// Build-time feature flags. Plain constants (no remote config) — flip and
// ship a build.

// Event chat (the per-event group chat opened from EventDetails' "Chat"
// button and listed on the Chats tab) — turned OFF 2026-09-03 "for now".
//
// What this gates (search for EVENT_CHAT_ENABLED):
//   - App.js: the "EventChat" stack screen is not registered.
//   - EventDetailsScreen: the Chat button is hidden and the event_chats
//     lookup is skipped.
//   - ChatsScreen: event chats are not loaded or listed (this is the one
//     that matters most — its per-row last-message/unread queries on
//     event_messages depended on the composite indexes removed below).
//
// Left in place, deliberately, so this is a one-line re-enable:
//   - screens/EventChatScreen.js, services/eventChatService.js, and every
//     shared chat component's "event" chatType branch are untouched.
//   - eventService.createEventChat still creates the event_chats room doc
//     on RSVP, so rooms exist for every event when this is turned back on.
//   - firestore.rules event_chats / event_messages blocks are untouched.
//   - The Cloud Functions triggers on event_messages (push, link unfurl,
//     deletion, pins, scheduled sends) are untouched — with no UI able to
//     write event_messages they simply never fire.
//
// To re-enable: set this to true AND restore the three event_messages
// composite indexes (chat_id+created_at, chat_id+pinned+pinned_at,
// chat_id+message_type+created_at) in firestore.indexes.json, then
// `firebase deploy --only firestore:indexes` and wait for them to build
// BEFORE shipping the build — the Chats tab queries fail without them.
export const EVENT_CHAT_ENABLED = false;

// Google Calendar hand-off after RSVP — put on the back burner 2026-09-23
// (owner: "just go with the old RSVP functionality... we will revisit once
// we get Google Calendar API access"). The URL-based hand-off went through
// 7 rounds (see utils/googleCalendar.js) and the native Google Calendar
// app's handling of the pre-filled draft is unreliable on Google's side.
//
// What this gates (search for GOOGLE_CALENDAR_ENABLED):
//   - EventDetailsScreen / ProfileScreen / ClubDetailsScreen: the
//     "You're going! Add to Google Calendar?" prompt after a successful RSVP
//     is not shown, and the "Remove from Google Calendar?" ask on un-RSVP is
//     skipped. RSVP / un-RSVP themselves are unchanged.
//
// Left in place for a one-line re-enable (or replacement by the Calendar
// API integration): components/GoogleCalendarPrompt.js,
// utils/googleCalendar.js, and eventService's device-local
// wasEventAddedToGcal / clearEventAddedToGcal flag helpers.
export const GOOGLE_CALENDAR_ENABLED = false;
